import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext({ user: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      // 401 on first load is expected for anonymous visitors — keep user null.
      if (err?.response?.status && err.response.status !== 401) {
        console.error("auth refresh failed:", err);
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const demoLogin = async () => {
    const { data } = await api.post("/auth/demo-login");
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, accepted_terms, legal_version, role = "buyer") => {
    const { data } = await api.post("/auth/register", { name, email, password, accepted_terms, legal_version, role });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (err) { console.warn("logout request failed:", err); }
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, loading, login, demoLogin, register, logout, refresh, isViewer: user?.role === "viewer" }),
    [user, loading]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
